// Tracks episode completion in the service worker and notifies the main thread
// to trigger a review prompt. An episode is considered complete when currentTime
// is within 15 seconds of the end (matching the restart threshold in play_button_controller).
export default class PlaybackReviewTrigger {
  static COMPLETION_THRESHOLD = 15;

  constructor() {
    this.completed = new Set();
  }

  onTimeUpdate(detail, notifyClient) {
    const { itemId, itemType, currentTime, duration } = detail;
    if (!duration || duration <= 0) return;

    const identifier = `${itemType}-${itemId}`;
    if (this.completed.has(identifier)) return;

    if (duration - currentTime <= PlaybackReviewTrigger.COMPLETION_THRESHOLD) {
      this.completed.add(identifier);
      notifyClient({ event: "supercast-episode-completed" });
    }
  }
}
